module.exports = __webpack_public_path__ + "img/06.0e2364df.png";